import { useEffect } from "react";

interface SeoOptions {
  title: string;
  description?: string;
  keywords?: string;
}

function setMeta(name: string, content: string, attr: "name" | "property" = "name") {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function useSeo({ title, description, keywords }: SeoOptions) {
  useEffect(() => {
    if (title) {
      document.title = title;
      setMeta("og:title", title, "property");
    }
    if (description) {
      setMeta("description", description);
      setMeta("og:description", description, "property");
    }
    if (keywords) {
      setMeta("keywords", keywords);
    }
  }, [title, description, keywords]);
}